// extracted by mini-css-extract-plugin
module.exports = {"appList":"AppList_appList__qC_Eq","truncateText":"AppList_truncateText__Tn_lH"};